import React, { useContext } from 'react';
import normalize from 'components/Dashboard/utilities/normalizeString';
import { useAuth0 } from '@auth0/auth0-react';
import { store } from 'components/Store';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import { filterFiltersOptionDependOnLocation } from 'components/Dashboard/Filters/filterFiltersOptionDependOnLocation';
import { Link, useLocation, useParams } from 'react-router-dom';
import FilterTypeRenderer from 'components/Dashboard/Filters/ui/FilterTypeRenderer';

const SeparateOutsideFilters = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan, search } = state;

  const { list } = search;
  const { subscriptionStatus, code, enableReferenceSection } = activePlan;
  const { hideFiltersQntty, filtersContext } = props;
  const { getDefaultSectionFilters, filtersState, applyFiltersFunction, filterTypeModifiers } = filtersContext;

  const sectionFilters = getDefaultSectionFilters(filtersState);

  const { isAuthenticated } = useAuth0();
  const params = useParams();

  const { inboxSection } = useMainSectionParameter(params);

  const trialUser =
    (subscriptionStatus === 'InTrial' && code.includes('Mogul')) ||
    subscriptionStatus === 'TrialEnded' ||
    !enableReferenceSection;
  const allowedUsers = (isAuthenticated && !trialUser) || inboxSection;
  const selectOption = () => {
    return ({ filter, newValue }) => {
      if (allowedUsers) {
        let newFilters = filterTypeModifiers({ filter, newValue });
        applyFiltersFunction(newFilters);
      }
    };
  };

  const separateFilters = sectionFilters.filter((item) => item.separateFilter);
  const location = useLocation();
  return (
    <>
      {separateFilters
        .filter((item) => !item.excludeFromPopup && item.separateFilter)
        .slice(hideFiltersQntty ? hideFiltersQntty + 1 : 0, undefined)
        .map((item, index) => {
          const { hidden, name, type, infoTooltip, rateFeedOption } = item;
          const showFilter = !hidden;
          const renderFilter = showFilter;
          const filteredOptionsItem = filterFiltersOptionDependOnLocation({
            item,
            filters: sectionFilters,
          });
          const filterProps = {
            filter: filteredOptionsItem,
            selectOption: selectOption(),
          };

          return (
            <div key={`separate-filter-${index}-${normalize(name)}`} className={'border rounded bg-main-white mb-2 '}>
              <div
                className={`specific-x-padding-20 ${rateFeedOption ? 'specific-top-padding-20 specific-bottom-padding-16' : 'specific-y-padding-20'} `}
              >
                <div className={`flex-centered justify-content-between mb-3`}>
                  <h3 className={`title-h5-bold d-block mb-0`}>{name}</h3>
                  {infoTooltip && (
                    <span
                      className='icon-info ml-2 main-subtle-text paragraph-p2'
                      data-tooltip-content={infoTooltip}
                      data-tooltip-id='general-tooltip'
                      data-tooltip-class-name={'general-tooltip pricing-feature-tooltip tooltip-width-280'}
                      data-tooltip-place='left'
                    ></span>
                  )}
                </div>
                <React.Fragment key={`section-filter-${index}-${normalize(name)}`}>
                  {renderFilter && (
                    <FilterTypeRenderer
                      filterProps={filterProps}
                      type={type}
                      allowedUsers={allowedUsers}
                      list={list}
                      isExpandedOnAction={false}
                      setExpanded={() => {}}
                      showMoreOptions={false}
                    />
                  )}
                </React.Fragment>
              </div>
              {rateFeedOption && (
                <div className='specific-x-padding-20 specific-top-padding-16 specific-bottom-padding-24 border-top'>
                  <p className='mb-0 light-80-text'>
                    <Link
                      to={{ search: `${location.search}${location.search ? '&' : '?'}mode=rate-updates` }}
                      state={{ prevUrl: `${location?.pathname}${location?.search}${location?.hash}` }}
                      className='text-light-blue text-underline-hover text-hover-light-blue'
                    >
                      Rate updates from your feed
                    </Link>{' '}
                    to improve what’s prioritised for you
                  </p>
                </div>
              )}
            </div>
          );
        })}
    </>
  );
};

export default SeparateOutsideFilters;
